





















import { defineComponent, onBeforeUnmount, PropType } from '@vue/composition-api'
import { TcButton } from '@telia/shared-ui-components'
import { Document } from '@contentful/rich-text-types'
import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'

export default defineComponent({
  components: {
    RichTextContainer,
    TcButton
  },
  props: {
    content: {
      type: Object as PropType<Document>,
      required: true
    },
    route: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  setup (_, context) {
    onBeforeUnmount(() => context.emit('close'))
  }
})

